import { render, staticRenderFns } from "./AddFilesAcceptance.vue?vue&type=template&id=ed2b09ce&scoped=true"
import script from "./AddFilesAcceptance.vue?vue&type=script&lang=js"
export * from "./AddFilesAcceptance.vue?vue&type=script&lang=js"
import style0 from "./AddFilesAcceptance.vue?vue&type=style&index=0&id=ed2b09ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2b09ce",
  null
  
)

export default component.exports